import { createFileRoute } from '@tanstack/react-router';
import { PostFormPage } from '@/components/admin/post-form/PostFormPage';

export const Route = createFileRoute('/admin/posts/new')({
  component: () => <PostFormPage />,
});
